import React, { FC } from "react";
import { useTranslation } from "next-i18next";
import {
    MessengerWidget as MessengerWidgetPackage,
    MessengerWidgetProps,
} from "@smile2impress/messenger-widget";
import { useUTSLocaleContext } from "context/utsLocaleContext";

export const MessengerWidget: FC<
    Omit<MessengerWidgetProps, "locale" | "i18n">
> = (props) => {
    const { i18n } = useTranslation();
    const { locale } = useUTSLocaleContext();

    return (
        <MessengerWidgetPackage {...props} locale={locale} i18n={{ i18n }} />
    );
};
